export const serverUrl = {
    baseUrl: `${process.env.REACT_APP_API_URL}/api`
    // baseUrl: `${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}/api`
    //was http://localhost:3001 before
}